// src/aws/rum.js
import { AwsRum } from 'aws-rum-web';

export function initRum() {
  try {
    const config = {
      sessionSampleRate: 1 ,
      identityPoolId: "eu-central-1:a6ee4bf5-e7da-4e64-be17-863de42a0d00" ,
      endpoint: "https://dataplane.rum.eu-central-1.amazonaws.com" ,
      telemetries: ["performance","errors","http"] ,
      allowCookies: true ,
      enableXRay: false ,
      signing: true // If you have a public resource policy and wish to send unsigned requests please set this to false
    };

    const APPLICATION_ID = 'bb0e3dc0-9121-4681-9deb-9fdc5143bd77';
    const APPLICATION_VERSION = '1.0.0';
    const APPLICATION_REGION = 'eu-central-1';

    new AwsRum(
      APPLICATION_ID,
      APPLICATION_VERSION,
      APPLICATION_REGION,
      config
    );
  } catch (error) {
    // Ignore errors thrown during CloudWatch RUM web client initialization
  }
}
